import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbsvgqe8qu: FaireProductEntity = {
  token: "p_bbsvgqe8qu",
  type: "product",
  name: "Hair Growth Multivitamin | Capsules (90 Capsules)",
  brandToken: "b_at5l4qlr",
  brandName: "Ancient Nutrition",
  imageUrl:
    "https://cdn.faire.com/fastly/93ffbf1187236c625caa432f6c84eb52ed58e014ebb1ea0e3967702f9217c765.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd461a4e94494d1c9b2ce6f936b4b8405f471d84fc9019d8567874515e62e9ae.jpeg",
    "https://cdn.faire.com/fastly/0c2749239c2fd2d5f6748157633190d9419581ec7f1f8a6f2a4f172995da7756.jpeg",
    "https://cdn.faire.com/fastly/9f2ca68c1f35af3ce287b6fd9b4c0c6dea6f128dbf5cd7b9edc54a8026c5d6a3.jpeg",
    "https://cdn.faire.com/fastly/55f592abaf9167d075845462d9b7c3462743c04e080c9792bf5d5d13d0f65964.jpeg",
    "https://cdn.faire.com/fastly/4292cc3df95eb58d3cb014af411f18065e580e55581a1449e3915cc52b085cfa.jpeg",
    "https://cdn.faire.com/fastly/dd046dcaa3dac75668ab2312a3e3b0cf2a4883da39bfdb3434e39aacf84d8cc0.jpeg",
  ],
  priceDollars: 29.97,
  description:
    "Get visibly thicker, shinier hair in 90 days† and the nutrients your body needs to thrive (including methylated B vitamins) with this peptide-powered formula. \n\n",
  tags: [],
  msrpDollars: 59.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:05.922Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
